import React, { Component } from 'react';
import { Row, Col, Modal, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import './ModalSucessRefund.css';

const defaultProps = { 
    firstButtonModal: 'OK',
    showModal: false,    
    messageCancelSucessTracker:'',
		messageCancelSucess:''
  };
  
  const propTypes = {
    id: PropTypes.string.isRequired,
    close: PropTypes.func.isRequired, 
    showModal: PropTypes.bool.isRequired,
    firstButtonModal: PropTypes.string,  
    header: PropTypes.string,
    messageCancelSucessTracker: PropTypes.any,
    messageCancelSucess: PropTypes.any,
    
  };
  
  class ModalSucessRefund extends Component {
    render() {    
      return (
        <Modal className='ModalSucessRefund-dialog'
          id={`modal-${this.props.id}`}
          show={this.props.showModal}
          onHide={this.props.close}>
          {this.props.header ? (
            <Modal.Header closeButton>
              <Modal.Title>{this.props.header}</Modal.Title>
            </Modal.Header>
          ) : null }
          <Modal.Body bsClass="ModalSucessRefund-body">
            <Row>  
              <Col sm={12} xs={12} md={12} lg={12} className="ModalSucessRefund-body-content">
                    <i className="icon-check-circle ModalSucessRefund-icon-check" />
               </Col>
            </Row>
            <Row>
             <Col
                id={`modal-${this.props.id}-messageTitle`}
                sm={12}
                xs={12}
                md={12}
                lg={12}
                className="ModalSucessRefund-messageTitle">                
              </Col>
              <Col
                id={`modal-${this.props.id}-message`}
                sm={12}
                xs={12}
                md={12}
                lg={12}
                className="ModalSucessRefund-body-content">
                {this.props.messageCancelSucessTracker}                
              </Col>

              {this.props.messageCancelSucess ? (
              <Col
                id={`modal-${this.props.id}-message`}
                sm={12}
                xs={12}
                md={12}
                lg={12}
                className="ModalSucessRefund-body-content">
                {this.props.messageCancelSucess}                
              </Col>
              )  : null}

            </Row>
          </Modal.Body>
          <Modal.Footer bsClass="ModalSucessRefund-footer">
            <Row>
              <Col sm={12} xs={12} md={12} lg={12}>
                <Button
                  bsClass="ModalSucessRefund-button"
                  id={`btn-modal-${this.props.id}`}
                  onClick={this.props.close}
                  ref={f => (this.firstOption = f)}>
                  {this.props.firstButtonModal}
                </Button>
                
              </Col>
            </Row>
          </Modal.Footer>
        </Modal>
      );
    }
  }

ModalSucessRefund.defaultProps = defaultProps;
ModalSucessRefund.propTypes = propTypes;

export default ModalSucessRefund;



// WEBPACK FOOTER //
// ./src/page/cancelPnr/components/modal/ModalSucessRefund.jsx